import {DI} from '../types'
import {ContainerModule, ContainerModuleLoadOptions} from 'inversify'


import {FormTestingRulesServiceInterface} from '@/src/features/functional-testing/core/rules-service.interface'
import {FunctionalTestingRulesService} from '@/src/features/functional-testing/infrastructure/rules-service'

const initializeModule = ({bind}: ContainerModuleLoadOptions) => {
  bind<FormTestingRulesServiceInterface>(DI.FunctionalTestingRulesServiceInterface).to(FunctionalTestingRulesService)
}

export const FormTestingModule = new ContainerModule(initializeModule)
